export const getTerminalInformationCode = {
  "curl": {
    "request": `curl -X 'POST'
    'https://demo-api.westpay.se/access/v2/getTerminalInfo'
    -H 'accept: text/plain'
    -H 'Ocp-Apim-Subscription-Key: <merchant-subscription-key>'
    -H 'Authorization: Bearer <access-token>'
    -H 'Content-Type: application/json'
    -d '{
    "customerId": 0,
    "storeId": "string",
    "merchantId": "string",
    "lastTransactionTime": "2024-10-10T09:14:04.690Z",
    "firstTransactionTime": "2024-10-10T09:14:04.690Z",
    "model": "string",
    "isActive": true,
  }'
  `
  },
  "java": {
    "request": `import com.fasterxml.jackson.databind.ObjectMapper;
    import java.io.IOException;
    import java.net.URI;
    import java.net.http.HttpClient;
    import java.net.http.HttpRequest;
    import java.net.http.HttpResponse;
    import java.net.http.HttpResponse.BodyHandlers;
      
    public class Main {
        public static void main(String[] args) {
            getTerminalInfoAsync();
        }
      
        static void getTerminalInfoAsync() {
            String apiUrl = "https://demo-api.westpay.se/access/v2/getTerminalInfo";
            String subscriptionKey = "<merchant-subscription-key>";
            String accessToken = "<access-token>";
      
            RequestData requestData = new RequestData(
                    0,
                    "string",
                    "string",
                    "2024-10-10T09:14:04.690Z",
                    "2024-10-10T09:14:04.690Z",
                    "string",
                    true
            );
      
            HttpClient httpClient = HttpClient.newBuilder().build();
      
            try {
                ObjectMapper objectMapper = new ObjectMapper();
                String requestBody = objectMapper.writeValueAsString(requestData);
      
                HttpRequest request = HttpRequest.newBuilder()
                        .uri(URI.create(apiUrl))
                        .header("accept", "text/plain")
                        .header("Ocp-Apim-Subscription-Key", subscriptionKey)
                        .header("Authorization", "Bearer " + accessToken)
                        .header("Content-Type", "application/json")
                        .POST(HttpRequest.BodyPublishers.ofString(requestBody))
                        .build();
      
                HttpResponse<String> response = httpClient.send(request, BodyHandlers.ofString());
      
                if (response.statusCode() == 200) {
                    String responseBody = response.body();
                    System.out.println("API response: " + responseBody);
                } else {
                    System.out.println("API request failed. Status code: " + response.statusCode());
                }
            } catch (IOException | InterruptedException e) {
                System.out.println("An error occurred while making the API request: " + e.getMessage());
            }
        }
      
        static class RequestData {
            private int customerId;
            private String storeId;
            private String merchantId;
            private String lastTransactionTime;
            private String firstTransactionTime;
            private String model;
            private boolean isActive;
      
            public RequestData(int customerId, String storeId, String merchantId, String lastTransactionTime, String firstTransactionTime, String model, boolean isActive) {
                this.customerId = customerId;
                this.storeId = storeId;
                this.merchantId = merchantId;
                this.lastTransactionTime = lastTransactionTime;
                this.firstTransactionTime = firstTransactionTime;
                this.model = model;
                this.isActive = isActive;
            }
      
            // Add getters and setters if needed
        }
    }
      `
  },
  "C#": {
    "request": `using System;
    using System.Net.Http;
    using System.Threading.Tasks;
      
    class Program
    {
        static async Task Main(string[] args)
        {
            await GetTerminalInfoAsync();
        }
      
        static async Task GetTerminalInfoAsync()
        {
            string apiUrl = "https://demo-api.westpay.se/access/v2/getTerminalInfo";
            string subscriptionKey = "<merchant-subscription-key>";
            string accessToken = "<access-token>";
      
            var requestData = new
            {
                customerId = 0,
                storeId = "string",
                merchantId = "string",
                lastTransactionTime = "2024-10-10T09:14:04.690Z",
                firstTransactionTime = "2024-10-10T09:14:04.690Z"
                model = "string",
                isActive = true,
            };
      
            using (var httpClient = new HttpClient())
            {
                httpClient.DefaultRequestHeaders.Add("accept", "text/plain");
                httpClient.DefaultRequestHeaders.Add("Ocp-Apim-Subscription-Key", subscriptionKey);
                httpClient.DefaultRequestHeaders.Add("Authorization", $"Bearer {accessToken}");
                httpClient.DefaultRequestHeaders.Add("Content-Type", "application/json");
      
                try
                {
                    var response = await httpClient.PostAsJsonAsync(apiUrl, requestData);
      
                    if (response.IsSuccessStatusCode)
                    {
                        var responseContent = await response.Content.ReadAsStringAsync();
                        Console.WriteLine("API response: " + responseContent);
                    }
                    else
                    {
                        Console.WriteLine("API request failed. Status code: " + response.StatusCode);
                    }
                }
                catch (HttpRequestException ex)
                {
                    Console.WriteLine("An error occurred while making the API request: " + ex.Message);
                }
            }
        }
    }
      `
  },
  "python": {
    "request": `import requests
    def get_terminal_info():
        api_url = 'https://demo-api.westpay.se/access/v2/getTerminalInf'
        subscription_key = '<merchant-subscription-key>'
        access_token = '<access-token>'
      
        request_data = {
            'customerId': 0,
            'storeId': 'string',
            'merchantId': 'string',
            'lastTransactionTime': '2024-10-10T09:14:04.690Z',
            'firstTransactionTime': '2024-10-10T09:14:04.690Z',
            'model': 'string',
            'isActive': True
        }
      
        headers = {
            'accept': 'text/plain',
            'Ocp-Apim-Subscription-Key': subscription_key,
            'Authorization': f'Bearer {access_token}',
            'Content-Type': 'application/json'
        }
      
        try:
            response = requests.post(api_url, json=request_data, headers=headers)
      
            if response.status_code == 200:
                print('API response:', response.text)
            else:
                print('API request failed. Status code:', response.status_code)
        except requests.RequestException as e:
            print('An error occurred while making the API request:', e)
      
    get_terminal_info()
      `
  },

  "JavaScript": {
    "request": `const axios = require('axios');

    async function getTerminalInfo() {
      const apiUrl = 'https://demo-api.westpay.se/access/v2/getTerminalInfo';
      const subscriptionKey = '<merchant-subscription-key>';
      const accessToken = '<access-token>';
      
      const requestData = {
        customerId: 0,
        storeId: 'string',
        merchantId: 'string',
        lastTransactionTime: '2024-10-10T09:14:04.690Z',
        firstTransactionTime: '2024-10-10T09:14:04.690Z',
        model: 'string',
        isActive: true
      };
      
      const headers = {
        accept: 'text/plain',
        'Ocp-Apim-Subscription-Key': subscriptionKey,
        Authorization: 'Bearer ' + accessToken',
        'Content-Type': 'application/json'
      };
      
      try {
        const response = await axios.post(apiUrl, requestData, { headers });
      
        if (response.status === 200) {
          console.log('API response:', response.data);
        } else {
          console.log('API request failed. Status code:', response.status);
        }
      } catch (error) {
        console.error('An error occurred while making the API request:', error.message);
      }
    }
      
    getTerminalInfo();
      `
  }
};

export const getTerminalInformationCodeResponse = `{
        "terminalInfo": [
          {
            "terminalId": "<filtered terminal id>",
            "parentName": "<filtered parent name>",
            "customerName": "<filtered customer name>",
            "merchantAcquirerReference": "<filtered acquirer reference>",
            "storeId": "<filtered store id>",
            "ecrId": "<filtered ecr id>",
            "serial": "<filtered serial>",
            "model": "<filtered model>",
            "paVersion": "<filtered pa version>",
            "applicationMode": "<filtered application mode>",
            "activatedTime": "<filtered activated time>",
            "lastTransactionTime": "<filtered last transaction time>",
            "currentParameters": "<filtered current parameters>",
            "isDecommissioned": <filtered isDecommissioned>,
            "decommissionedTime": "<filtered decommissioned time>",
            "isActive": <filtered is active>
          }
        ]
      }
      `;
